export default {"src":"/_next/static/media/payment-amex-icon.ce41ca13.svg","height":20,"width":29};